import { create } from "zustand";
import { persist } from "zustand/middleware";
import { EMPTY_ACTION_FILTERS } from "utils/actionFilters";

// How the person looks at their actions. Group by, sort, visibility and
// filters survive a reload; the search text does not.
const useActionsViewStore = create(
  persist(
    (set) => ({
      groupBy: "due",
      sortBy: "due",
      visibility: "both",
      filters: EMPTY_ACTION_FILTERS,
      search: "",
      // Ids added in this view, newest last. They show in a "Just added"
      // group at the top until the tab changes or the view closes.
      recentIds: [],
      // The composer draft, shared by the Actions page view and the narrow
      // workspace panel, so resizing the panel keeps the text and files.
      draftHtml: "",
      draftFiles: [],
      setDraftHtml: (next) =>
        set((state) => ({
          draftHtml: typeof next === "function" ? next(state.draftHtml) : next,
        })),
      setDraftFiles: (next) =>
        set((state) => ({
          draftFiles: typeof next === "function" ? next(state.draftFiles) : next,
        })),
      // List animations are off while a page of older actions goes in.
      animationsPaused: false,
      setAnimationsPaused: (animationsPaused) => set({ animationsPaused }),
      addRecentId: (id) =>
        set((state) => ({ recentIds: [...state.recentIds.filter((x) => x !== id), id] })),
      clearRecent: () => set((state) => (state.recentIds.length ? { recentIds: [] } : state)),
      setGroupBy: (groupBy) => set({ groupBy }),
      setSortBy: (sortBy) => set({ sortBy }),
      setVisibility: (visibility) => set({ visibility }),
      setSearch: (search) => set({ search }),
      setFilters: (filters) => set({ filters }),
      clearFilters: () => set({ filters: EMPTY_ACTION_FILTERS }),
      // A click on a label in the side menu shows only that label, and a
      // second click clears it.
      toggleOnlyLabel: (labelId) =>
        set((state) => {
          const current = state.filters.labelIds;
          const isOnly = current.length === 1 && current[0] === labelId;
          return {
            filters: { ...state.filters, labelIds: isOnly ? [] : [labelId] },
          };
        }),
    }),
    {
      name: "gaintime-actions-view",
      partialize: ({ groupBy, sortBy, visibility, filters }) => ({
        groupBy,
        sortBy,
        visibility,
        filters,
      }),
      merge: (persisted, current) => ({
        ...current,
        ...persisted,
        filters: { ...EMPTY_ACTION_FILTERS, ...(persisted?.filters || {}) },
      }),
    }
  )
);

export default useActionsViewStore;
